"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fscreen = _interopRequireDefault(require("fscreen"));

const forceRedraw = element => {
  const oldDisplay = element.style.display;
  element.style.display = 'none';
  element.offsetHeight; // trick to force redraw

  element.style.display = oldDisplay;
};

const fullscreen = (() => {
  const isFullySupported = _fscreen.default.fullscreenEnabled; // when the full API is not available but `webkitEnterFullscreen` exists on video elements, we're probably on an iPhone
  // which can fullscreen video tags but nothing else

  let isPartiallySupported = false;

  if (global.document && !isFullySupported && document.createElement('video').webkitEnterFullscreen) {
    isPartiallySupported = true;
  }

  const isSupported = isFullySupported || isPartiallySupported;

  const onChange = ev => {
    const el = ev.target;

    if (_fscreen.default.fullscreenElement === null && el) {
      _fscreen.default.removeEventListener('fullscreenchange', onChange, false);

      forceRedraw(el);
    }
  };

  const request = el => new Promise((resolve, reject) => {
    if (isFullySupported) {
      _fscreen.default.requestFullscreen(el);

      resolve();

      _fscreen.default.addEventListener('fullscreenchange', onChange, false);
    } else if (isPartiallySupported) {
      try {
        el.querySelector('video').webkitEnterFullscreen();
        resolve();
      } catch (e) {
        reject(new Error('failed entering fullscreen in partially-supported mode'));
      }
    } else {
      console.warn('fullscreen is not supported for this device');
      reject(new Error('fullscreen not supported'));
    }
  });

  const exit = el => new Promise((resolve, reject) => {
    if (_fscreen.default.fullscreenElement) {
      _fscreen.default.exitFullscreen();

      resolve();
    } else if (el.querySelector('video').webkitDisplayingFullscreen) {
      el.querySelector('video').webkitExitFullscreen();
    } else {
      reject(new Error('not in fullscreen mode'));
    }
  });

  return {
    isFullySupported,
    isPartiallySupported,
    isSupported,
    request,
    exit
  };
})();

var _default = fullscreen;
exports.default = _default;